import { render, staticRenderFns } from "./RegisterMarketplaceCategoria.html?vue&type=template&id=1b063298&external"
import script from "./RegisterMarketplaceCategoria.vue?vue&type=script&lang=js"
export * from "./RegisterMarketplaceCategoria.vue?vue&type=script&lang=js"
import style0 from "./RegisterMarketplaceCategoria.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports